export const FIND_SPOT_LIST_REQUEST = 'FIND_SPOT_LIST_REQUEST';

export const findSpotListRequest = ( id: string ) => ({
    type: FIND_SPOT_LIST_REQUEST,
    payload: { id }
});
